function getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData) {
  if (!ajaxPage) ajaxPage = 0;
  if (!allAjaxData) allAjaxData = [];

  // We can only get 20 products per ajax call, if there are more than 20 products per page, we need to call multiple times
  if (!numberProductPerAjaxCall || numberProductPerAjaxCall > 20) {
    numberProductPerAjaxCall = 20;
  }
  var fromIndex = numberProductPerAjaxCall * ajaxPage;
  var toIndex = Math.min(data.length, numberProductPerAjaxCall * (ajaxPage + 1));
  var handles = [];
  for (var i = fromIndex; i < toIndex; i++) {
    handles.push(data[i].handle);
  }

  // No more products at all (can happen if data.length is an exact multiple of
  // numberProductPerAjaxCall and we get called one page too many) — stop instead
  // of silently deadlocking.
  if (handles.length === 0) {
    if (typeof callback === 'function') {
      callback(allAjaxData);
    }
    return;
  }

  const chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
  const handleChunks = chunk(handles, 10);

  var pendingChunks = handleChunks.length;
  var mergedChunkData = [];

  handleChunks.forEach(group => {
    const itemDataUrl = '/collections/all/' + group.join('+') + '?view=boost-multiple-currencies';

    jQ.ajax({
      type: 'GET',
      url: itemDataUrl,
      success: function (ajaxData) {
        var parsed = parseExtrasAjaxData(ajaxData, templateName);
        mergedChunkData = mergedChunkData.concat(parsed);
        chunkDone();
      },
      error: function () {
        // Don't let a single failed chunk hang the whole chain forever.
        chunkDone();
      }
    });
  });

  function chunkDone() {
    pendingChunks--;
    if (pendingChunks > 0) return; // wait for every chunk in this page

    // All chunks for this page are back — merge into the running total exactly once.
    var newAllAjaxData = allAjaxData.concat(mergedChunkData);

    if (toIndex < data.length) {
      // There is still more data beyond this page — fetch the next page.
      getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage + 1, newAllAjaxData);
    } else {
      // Everything has been fetched — resolve exactly once with the full merged list.
      if (typeof callback === 'function') {
        callback(newAllAjaxData);
      }
    }
  }
}

function parseExtrasAjaxData(ajaxData, templateName) {
  try {
    if (/<\!--.*?-->/.test(ajaxData)) {
      ajaxData = ajaxData.replace(/<\!--.*?-->/g, '');
    }
    return JSON.parse(ajaxData).products || [];
  } catch (error) {
    console.error('Could not parse json from ' + templateName + ': ' + error.message);
    return [];
  }
}

function applyMultiCurrencyPrices(result, productsData) {
  var currency = boostPFSConfig.general.current_currency.toLowerCase();

  productsData.forEach(function (product) {
    var idx = result.products.findIndex(function (apiProduct) { return apiProduct.id === product.id; });
    if (idx >= 0) {
      result.products[idx].compare_at_price_min = product.compare_at_price_min / 100;
      result.products[idx].price_min = product.price_min / 100;
      result.products[idx].price_max = product.price_max / 100;

      result.products[idx]['compare_at_price_min_' + currency] = product.compare_at_price_min / 100;
      result.products[idx]['price_min_' + currency] = product.price_min / 100;
      result.products[idx]['price_max_' + currency] = product.price_max / 100;
    }
  });
}

if (typeof FilterApi !== 'undefined') {
  FilterApi.afterCallAsync = function (result, callbackFilterApi) {
    if (result.products.length === 0) {
      callbackFilterApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, 'boost-multiple-currencies', function (productsData) {
      applyMultiCurrencyPrices(result, productsData);
      callbackFilterApi(result);
    });
  };
}

if (typeof InstantSearchApi !== 'undefined') {
  InstantSearchApi.afterCallAsync = function (result, callbackInstantSearchApi) {
    if (result.products.length === 0) {
      callbackInstantSearchApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, 'boost-multiple-currencies', function (productsData) {
      applyMultiCurrencyPrices(result, productsData);
      callbackInstantSearchApi(result);
    });
  };
}